export var IntakeStatus;
(function (IntakeStatus) {
    IntakeStatus["Complete"] = "COMPLETE";
    IntakeStatus["CompleteCheckedOut"] = "COMPLETE_CHECKED_OUT";
    IntakeStatus["InProgress"] = "IN_PROGRESS";
    IntakeStatus["NotStarted"] = "NOT_STARTED";
    IntakeStatus["NotStartedWarning"] = "NOT_STARTED_WARNING";
})(IntakeStatus || (IntakeStatus = {}));
